(() => {
  const banners = Array.from(document.querySelectorAll('[data-warehouse-sale-banner]'));
  if (!banners.length) return;

  const pad = (value) => String(value).padStart(2, '0');

  const update = () => {
    const now = Date.now();

    banners.forEach((banner) => {
      const end = Date.parse(banner.dataset.end || '');
      const timer = banner.querySelector('[data-warehouse-sale-countdown]');

      if (!Number.isFinite(end) || !timer) return;

      const remaining = end - now;
      if (remaining <= 0) {
        banner.hidden = true;
        return;
      }

      banner.hidden = false;

      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      const daySegment = days > 0 ? `${pad(days)}D ` : '';
      timer.textContent = `${daySegment}${pad(hours)}H ${pad(minutes)}M ${pad(seconds)}S`;
    });
  };

  update();
  const interval = window.setInterval(() => {
    update();

    if (banners.every((banner) => banner.hidden)) {
      window.clearInterval(interval);
    }
  }, 1000);
})();
